import React from 'react';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import Select from '../../../../../components/input/Select/Select';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenOrderDeliveryTracking from '../../../../../containers/app/common/OpenOrderDeliveryTracking';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import SendMessageService from '../../../../../containers/app/common/SendMessageService';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  ORDER_DELIVERY_TYPE,
  ORDER_DELIVERY_TYPE_TEXT,
  ORDER_ITEM_STATUS,
  ORDER_ITEM_STATUS_TEXT,
  PAY_METHOD_TYPE_TEXT,
  ORDER_ITEM_STATUS_SELECT_LIST,
} from '../../../../../constants/service/app/orderConstants';
import {
  setDash,
  setPhoneFormat,
  setNumberWithComma,
  addAllItemToSelectList,
  setColumnWidth,
  setClearDash,
} from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 * 주문 내역 리스트 컬럼
 */
export const columns = (data) => {
  const { list, filterOption, onFilter } = data;

  return [
    {
      accessor: 'orderId',
      Header: '주문번호',
      filterable: true,
      fixed: 'left',
      width: 150,
      Filter: () => <TableFilterInput option={filterOption.orderId} onFilter={(orderId) => onFilter({ orderId })} />,
    },
    {
      accessor: 'orderItemId',
      Header: '상품 주문번호',
      filterable: true,
      fixed: 'left',
      width: 150,
      Cell: (row) => <OpenOrderItemDetail text={row.value} orderItemId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.orderItemId} onFilter={(orderItemId) => onFilter({ orderItemId })} />
      ),
    },
    {
      accessor: 'storeName',
      Header: '브랜드명',
      filterable: true,
      width: 150,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      width: 100,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'storePhone',
      Header: '브랜드 연락처',
      width: 130,
      Cell: (row) => setPhoneFormat(row.value),
    },
    {
      accessor: 'sellerAccount',
      width: 180,
      Header: '판매자 계정',
    },
    {
      accessor: 'sellerName',
      Header: '판매자명',
      width: 130,
      Cell: (row) => `${row.value}(${row.original.sellerId})`,
    },
    {
      accessor: 'sellerPhone',
      Header: '판매자 연락처',
      width: 130,
      Cell: (row) => (
        <SendMessageService
          text={setPhoneFormat(row.value)}
          memberType={AMONDZ_MEMBER_TYPE.SELLER}
          targetId={row.original.storeId}
        />
      ),
    },
    {
      accessor: 'deliveryType',
      Header: '배송방법',
      Cell: (row) => ORDER_DELIVERY_TYPE_TEXT[row.value] || '_',
    },
    {
      accessor: 'deliveryEnterprise',
      Header: '택배사',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'invoiceNumber',
      Header: '송장 번호',
      Cell: (row) => setDash(row.value),
    },
    {
      Header: '배송 추적',
      Cell: (row) => {
        /**
         * 상품 주문 상태가 배송 중/배송 완료이며, 택배방법이 [택배, 등기, 소포]일 경우에만 추적 활성화
         */
        if (
          (row.original.orderItemStatus === ORDER_ITEM_STATUS.SHIPPING ||
            row.original.orderItemStatus === ORDER_ITEM_STATUS.DELIVERY_COMPLETE) &&
          row.original.deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY
        )
          return <OpenOrderDeliveryTracking deliveryId={row.original.deliveryId} />;
        else return setDash(row.value);
      },
    },
    {
      accessor: 'orderItemStatus',
      Header: '상품 주문 상태',
      filterable: true,
      width: 150,
      Cell: (row) => ORDER_ITEM_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(ORDER_ITEM_STATUS_SELECT_LIST)}
          onChange={(orderItemStatus) => onFilter({ orderItemStatus })}
          defaultValue={filterOption.orderItemStatus}
          value={filterOption.orderItemStatus}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'orderDate',
      Header: '주문 일시',
      filterable: true,
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.orderDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(orderDate) => onFilter({ orderDate })}
        />
      ),
    },
    {
      accessor: 'paymentDate',
      Header: '결제 일시',
      filterable: true,
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.paymentDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(paymentDate) => onFilter({ paymentDate })}
        />
      ),
    },
    {
      accessor: 'deliveryPrepareDate',
      Header: '상품 준비 일시',
      filterable: true,
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.deliveryPrepareDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(deliveryPrepareDate) => onFilter({ deliveryPrepareDate })}
        />
      ),
    },
    {
      accessor: 'deliveryDispatchDate',
      Header: '발송 처리 일시',
      filterable: true,
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.deliveryDispatchDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(deliveryDispatchDate) => onFilter({ deliveryDispatchDate })}
        />
      ),
    },
    {
      accessor: 'deliveryCompleteDate',
      Header: '배송 완료 일시',
      filterable: true,
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.deliveryCompleteDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(deliveryCompleteDate) => onFilter({ deliveryCompleteDate })}
        />
      ),
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      filterable: true,
      width: 130,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      filterable: true,
      className: 'align-left',
      resizable: true,
      width: setColumnWidth(list, 'productName'),
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'productOptionName',
      Header: '옵션정보',
      resizable: true,
      width: setColumnWidth(list, 'productOptionName'),
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'quantity',
      Header: '수량',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'productOriginalPrice',
      Header: '상품 가격(정가)',
      width: 130,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'productDiscountPrice',
      Header: '상품 할인액(차감된 금액)',
      width: 160,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'productOptionPrice',
      Header: '옵션 가격',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'usedCoupon',
      Header: '쿠폰',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'usedPoint',
      Header: '포인트',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'totalPrice',
      Header: '상품별 총 주문금액',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'deliveryExtraFee',
      Header: '추가 배송비',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'buyerPhone',
      Header: '구매자 연락처',
      filterable: true,
      width: 130,
      Cell: (row) => (
        <SendMessageService
          text={setPhoneFormat(row.value)}
          memberType={AMONDZ_MEMBER_TYPE.USER}
          targetId={row.original.userId}
        />
      ),
      Filter: () => (
        <TableFilterInput
          option={filterOption.buyerPhone}
          onFilter={(buyerPhone) =>
            onFilter({
              buyerPhone: setClearDash(buyerPhone),
            })
          }
        />
      ),
    },
    {
      accessor: 'recipientPhone',
      Header: '수취인 연락처',
      filterable: true,
      width: 130,
      Cell: (row) => (
        <SendMessageService
          text={setPhoneFormat(row.value)}
          memberType={AMONDZ_MEMBER_TYPE.RECIPIENT}
          targetId={row.original.orderItemId}
        />
      ),
      Filter: () => (
        <TableFilterInput
          option={filterOption.recipientPhone}
          onFilter={(recipientPhone) =>
            onFilter({
              recipientPhone: setClearDash(recipientPhone),
            })
          }
        />
      ),
    },
    {
      accessor: 'recipientName',
      Header: ' 수취인명',
    },
    {
      accessor: 'address',
      Header: '배송지',
      resizable: true,
      width: setColumnWidth(list, 'address'),
    },
    {
      accessor: 'postCode',
      Header: '우편번호',
    },
    {
      accessor: 'message',
      Header: '배송 메시지',
      resizable: true,
      width: setColumnWidth(list, 'message'),
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'payMethod',
      Header: '결제수단',
      width: 130,
      Cell: (row) => PAY_METHOD_TYPE_TEXT[row.value] || '_',
    },
  ];
};
